import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { ErroresHandler } from 'src/app/base/tools/handler/error.handler';
import { Curso } from '../../interfaces/curso';
import { CursosService } from '../../services/cursos.service';
import { animations } from '../../tools/animations';

@Component({
  selector: 'app-cursos-ofertados',
  templateUrl: './cursos-ofertados.component.html',
  styleUrls: ['./cursos-ofertados.component.css'],
  animations: animations
})
export class CursosOfertadosComponent implements OnInit {

  public cursos: Curso[];
  public cursosGratuitos: Curso[];
  public cursosDePago: Curso[];
  public cursosPrivados: Curso[];

  public loadingGratuitos: boolean = false;
  public loadingPago: boolean = false;
  public loadingPrivado: boolean = false;
  public loadingCursos: boolean = false;

  constructor(
    private cursosService: CursosService,
    private erroresHandler: ErroresHandler
  ) { }

  ngOnInit(): void {
    this.loadingGratuitos = true;
    this.loadingPago = true;
    this.loadingPrivado = true;
    this.loadingCursos = true;

    this.cursosService.getCursosGratuitos().then((_data: Curso[]) => {
      this.cursosGratuitos = _data;
      this.loadingGratuitos = false;
    }).catch(e => {
      this.erroresHandler.processError(
          e,
          'alert',
          'Ocurrió un problema al cargar los cursos gratuitos',
          'Error'
      );
    });

    this.cursosService.getCursosDePago().then((_data: Curso[]) => {
      this.cursosDePago = _data;
      this.loadingPago = false;
    }).catch(e => {
      this.erroresHandler.processError(
          e,
          'alert',
          'Ocurrió un problema al cargar los cursos de pago',
          'Error'
      );
    });

    this.cursosService.getCursosPrivados().then((_data: Curso[]) => {
      this.cursosPrivados = _data;
      this.loadingPrivado = false;
    }).catch(e => {
      this.erroresHandler.processError(
          e,
          'alert',
          'Ocurrió un problema al cargar los cursos privados',
          'Error'
      );
    });

    this.cursosService.getCursosOfertados().then((_data: Curso[]) => {
      this.cursos = _data;
      this.loadingCursos = false;
    })
    .catch(e => {
      this.erroresHandler.processError(
          e,
          'alert',
          'No se pueden cargar los cursos, intente nuevamente',
          'Error'
      );
    });

  }

}
